// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, Badge, Button } from "react-bootstrap";
// import {
//   IoHeartOutline,
//   IoStar,
//   IoInformationCircleOutline,
//   IoClose,
// } from "react-icons/io5";
// import BASE_URL from "../../component/commanfile";

// const TourCard = ({ tour, viewMode, activeType }) => {
//   const [showTooltip, setShowTooltip] = useState(null);
//   const navigate = useNavigate();

//   const handleCardClick = () => {
//     // navigate(`/tour-details/${tour.id}`);
//     navigate(`/tour-details/${activeType == "fit" ? `fit-${tour?.id}` : tour?.id}`, {
//       state: {
//         tourId: tour?.id,
//       }
//     });
//   };

//   const renderStars = (rating) => {
//     return [...Array(rating)].map((_, i) => (
//       <IoStar key={i} color="#f4c542" size={18} />
//     ));
//   };

//   const toggleTooltip = (tooltipName) => {
//     setShowTooltip((prev) => (prev === tooltipName ? null : tooltipName));
//   };

//   // Outside the component (global)
//   const CLASSES = [
//     "bg-danger",
//     "bg-primary",
//     "bg-success",
//     "bg-warning",
//     "bg-info",
//     "bg-secondary",
//     "bg-dark",
//   ];

//   const categoryIdColorMap = {}; // maps category id => class

//   // Function to get class for a category ID
//   function getColorForCategoryId(id) {
//     if (!id) return "bg-secondary"; // fallback
//     if (categoryIdColorMap[id]) return categoryIdColorMap[id];

//     // Assign next color in CLASSES array
//     const cls = CLASSES[Object.keys(categoryIdColorMap).length % CLASSES.length];
//     categoryIdColorMap[id] = cls;
//     return cls;
//   }


//   const forfitArray = Array.isArray(tour?.forfit)
//     ? tour.forfit
//     : tour?.forfit
//       ? [tour.forfit]
//       : [];

//   let minFitPrice = null;

//   if (activeType === "fit") {
//     forfitArray.forEach(item => {
//       if (Array.isArray(item?.seatConfigurationRate)) {
//         item.seatConfigurationRate.forEach(rate => {
//           if (typeof rate?.price === "number") {
//             if (minFitPrice === null || rate.price < minFitPrice) {
//               minFitPrice = rate.price;
//             }
//           }
//         });
//       }
//     });
//   }

//   console.log("tour======>", tour)
//   return (
//     <Card
//       className={`tour-card ${viewMode === "list" ? "list-view-card" : ""}`}
//     >
//       <div className="card-content-wrapper" onClick={handleCardClick}>
//         <div className="card-image-container cursor-pointer">
//           <img
//             variant="top"
//             src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.thumbnail?.substring(1))}`}
//             alt={tour.title}
//           />
//         </div>
//         <Card.Body>
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <div>

//               {tour?.categoryList?.map((cat) => (
//                 <Badge
//                   key={cat.id}
//                   className={`${getColorForCategoryId(cat.id)} me-2`}
//                 >
//                   {cat.name}
//                 </Badge>
//               ))}


//             </div>
//             <Button variant="link" className="favorite-btn p-0">
//               <IoHeartOutline color="#be0f0fff" size={20} fill="#be0f0fff" />
//             </Button>
//           </div>

//           <Card.Title
//             className="tour-title cursor-pointer"
//             onClick={handleCardClick}
//           >
//             {tour.name}
//           </Card.Title>

//           <div className="d-flex align-items-center mb-2">
//             {renderStars(Number(tour.rating))}
//             <span className="ms-2 text-muted review-count">
//               {tour.reviews} Reviews
//             </span>
//           </div>

//           <p className="text-muted mb-2 tour-brief">

//             <span
//               className="ms-1 tooltip-trigger"
//               onClick={() => toggleTooltip("cities")}
//             >
//               - {tour?.duration} days {tour?.duration - 1} nights

//             </span>
//             <span className="info-tooltip position-relative">
//               <span
//                 className="ms-1 tooltip-trigger"
//                 onClick={() => toggleTooltip("cities")}
//               >
//                 - {tour?.description}

//               </span>

//             </span>
//           </p>

//           <p className="text-success mb-2 position-relative">

//             {showTooltip === "highlights" && (
//               <span className="tooltip-popup">
//                 Additional Highlights: {tour?.additionalHighlights?.join(", ") ? tour?.additionalHighlights?.join(", ") : "N/A"}
//                 <Button
//                   variant="link"
//                   className="close-btn p-0"
//                   onClick={() => setShowTooltip(null)}
//                 >
//                   <IoClose color="#6c757d" size={16} />
//                 </Button>
//               </span>
//             )}
//           </p>
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="price">
//               ₹{
//                 activeType === "fit" && minFitPrice !== null
//                   ? minFitPrice.toLocaleString()
//                   : tour?.doubleOccupancy?.toLocaleString()
//               }
//               <small> per person</small>
//             </span>

//             <Button className="p-1">Enquire Now</Button>
//           </div>


//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <Button variant="outline-primary" size="sm">
//               View Tour Details
//             </Button>
//             <Button variant="warning">Book Online</Button>
//           </div>


//         </Card.Body>
//       </div>
//     </Card>
//   );
// };

// export default TourCard;


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, Badge, Button } from "react-bootstrap";
// import {
//   IoHeartOutline,
//   IoStar,
//   IoInformationCircleOutline,
//   IoClose,
// } from "react-icons/io5";
// import BASE_URL from "../../component/commanfile";

// const TourCard = ({ tour, viewMode, activeType }) => {
//   const [showTooltip, setShowTooltip] = useState(null);
//   const navigate = useNavigate();

//   const handleCardClick = () => {
//     // navigate(`/tour-details/${tour.id}`);
//     navigate(`/tour-details/${tour.type == "fit" ? `fit-${tour?.id}` : tour?.id}`, {
//       state: {
//         tourId: tour?.id,
//       }
//     });
//   };


//   const toggleTooltip = (tooltipName) => {
//     setShowTooltip((prev) => (prev === tooltipName ? null : tooltipName));
//   };

//   // Outside the component (global)
//   const CLASSES = [
//     "bg-danger",
//     "bg-primary",
//     "bg-success",
//     "bg-warning",
//     "bg-info",
//     "bg-secondary",
//     "bg-dark",
//   ];

//   const categoryIdColorMap = {}; // maps category id => class

//   // Function to get class for a category ID
//   function getColorForCategoryId(id) {
//     if (!id) return "bg-secondary"; // fallback
//     if (categoryIdColorMap[id]) return categoryIdColorMap[id];

//     // Assign next color in CLASSES array
//     const cls = CLASSES[Object.keys(categoryIdColorMap).length % CLASSES.length];
//     categoryIdColorMap[id] = cls;
//     return cls;
//   }


//   const forfitArray = Array.isArray(tour?.forfit)
//     ? tour.forfit
//     : tour?.forfit
//       ? [tour.forfit]
//       : [];

//   let minFitPrice = null;

//   if (tour.type == "fit") {
//     forfitArray.forEach(item => {
//       if (Array.isArray(item?.seatConfigurationRate)) {
//         item.seatConfigurationRate.forEach(rate => {
//           if (typeof rate?.price === "number") {
//             if (minFitPrice === null || rate.price < minFitPrice) {
//               minFitPrice = rate.price;
//             }
//           }
//         });
//       }
//     });
//   }
// const showConnectForRateBtn =
//   tour.type === "fit" && (minFitPrice === null || minFitPrice <= 0);


//   return (
//     <Card
//       className={`tour-card ${viewMode === "list" ? "list-view-card" : ""}`}
//     >
//       <div className="card-content-wrapper" onClick={handleCardClick}>
//        <div className="card-image-container cursor-pointer position-relative">
//   <img
//     variant="top"
//     src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.thumbnail?.substring(1))}`}
//     alt={tour.title}
//   />

//   {/* Add type badge on right side */}
//   <div
//     className="type-badge position-absolute top-0 end-0 m-2 px-2 py-1 text-white"
//     style={{
//       backgroundColor: tour.type == "fit" ? "#28a745" : "#007bff", // green for Fit, blue for package
//       borderRadius: "4px",
//       fontSize: "12px",
//     }}
//   >
//     {tour.type === "fit" ? "Fit" : "Package"}
//   </div>
// </div>

//         <Card.Body>
//           <div className="d-flex justify-content-between align-items-center mb-2">


//           </div>

//           <Card.Title
//             className="tour-title cursor-pointer"
//             style={{
//               fontSize:"18px"
//             }}
//             onClick={handleCardClick}
//           >
//             {tour.name}
//           </Card.Title>
//           <p className="text-muted mb-2 tour-brief">

//             <span
//               className="ms-1 tooltip-trigger"
//               onClick={() => toggleTooltip("cities")}
//             >
//                {tour?.type == "fit" ?  `${tour?.tour_itineraries?.length || 0} days ${tour?.tour_itineraries?.length - 1 || 0} nights`  : `${tour?.duration || 0} days ${tour?.duration - 1} nights`}

//             </span>
//           </p>

//           <p className="text-success mb-2 position-relative">

//             {showTooltip === "highlights" && (
//               <span className="tooltip-popup">
//                 Additional Highlights: {tour?.additionalHighlights?.join(", ") ? tour?.additionalHighlights?.join(", ") : "N/A"}
//                 <Button
//                   variant="link"
//                   className="close-btn p-0"
//                   onClick={() => setShowTooltip(null)}
//                 >
//                   <IoClose color="#6c757d" size={16} />
//                 </Button>
//               </span>
//             )}
//           </p>
//         {!showConnectForRateBtn && (
//   <div className="d-flex justify-content-between align-items-center mb-2">
//     <span className="price">
//       ₹
//       {tour.type === "fit"
//         ? minFitPrice?.toLocaleString()
//         : tour?.doubleOccupancy?.toLocaleString()}
//       <small> Start From</small>
//     </span>
//   </div>
// )}



//   {showConnectForRateBtn && (
//     <Button
//       className="p-1 w-100 mb-2"
//       variant="outline-success"
//       onClick={(e) => {
//         e.stopPropagation(); // card click se bachane ke liye
//         window.open("https://wa.me/919999999999", "_blank");
//       }}
//     >
//       Connect for Rate
//     </Button>
//   )}
//             <Button className="p-1 w-100">View Now</Button>
//         </Card.Body>
//       </div>
//     </Card>
//   );
// };

// export default TourCard;


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, Button, Modal, Form, InputGroup } from "react-bootstrap";
// import { IoPersonCircle, IoCallOutline } from "react-icons/io5";
// import BASE_URL from "../../component/commanfile";
// import {
//   BsPersonCheck,
//   BsBuilding,
//   BsEggFried,
//   BsBusFront,
//   BsCamera,
//   BsAirplane,
// } from "react-icons/bs";
// import {
//   MdDinnerDining,
//   MdOutlineEmail,
// } from "react-icons/md";
// import { FaWhatsapp } from "react-icons/fa";
// const TourCard = ({ tour, viewMode }) => {
//   const [showRateModal, setShowRateModal] = useState(false);
//   const [formData, setFormData] = useState({ name: "", contactNumber: "" });
//   const [adultCount, setAdultCount] = useState(1);
//   const [childrenCount, setChildrenCount] = useState(0);

//   const navigate = useNavigate();

//   // Price Calculation Logic
//   const forfitArray = Array.isArray(tour?.forfit) ? tour.forfit : tour?.forfit ? [tour.forfit] : [];
//   let minFitPrice = null;
//   if (tour.type === "fit") {
//     forfitArray.forEach((item) => {
//       item?.seatConfigurationRate?.forEach((rate) => {
//         if (typeof rate?.price === "number") {
//           if (minFitPrice === null || rate.price < minFitPrice) minFitPrice = rate.price;
//         }
//       });
//     });
//   }

//   const showConnectForRateBtn = tour.type === "fit" && (minFitPrice === null || minFitPrice <= 0);

//   const handleCardClick = () => {
//     navigate(`/tour-details/${tour.type === "fit" ? `fit-${tour?.id}` : tour?.id}`, {
//       state: { tourId: tour?.id }
//     });
//   };

//   const isFormValid = formData.name.trim() !== "" && formData.contactNumber.trim().length === 10;

//   let includesArray = [];
//   if (Array.isArray(tour?.includes)) {
//     includesArray = tour.includes;
//   } else if (typeof tour?.includes === "string") {
//     try {
//       // Try parsing JSON string first
//       includesArray = JSON.parse(tour.includes);
//       if (!Array.isArray(includesArray)) {
//         includesArray = tour.includes
//           .split(",")
//           .map((i) => i.trim())
//           .filter(Boolean);
//       }
//     } catch {
//       // Fallback: comma-separated string
//       includesArray = tour.includes
//         .split(",")
//         .map((i) => i.trim())
//         .filter(Boolean);
//     }
//   } else {
//     includesArray = [];
//   }
//   const includeOptions = {
//     tour_manager: { icon: <BsPersonCheck />, label: "Tour Manager" },
//     hotel: { icon: <BsBuilding />, label: "Hotel" },
//     meals: { icon: <MdDinnerDining />, label: "Meals" },
//     transport: { icon: <BsBusFront />, label: "Transport" },
//     sightseeing: { icon: <BsCamera />, label: "Sightseeing" },
//     flight: { icon: <BsAirplane />, label: "Flight*" },
//   };
//   return (
//     <>
//       <Card className={`rs-slim-card ${viewMode === "list" ? "rs-list-view" : ""}`}>
//         {/* Image Section - Height Controlled */}
//         <div className="rs-card-img-wrapper" onClick={handleCardClick}>
//           <img
//             src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.thumbnail?.substring(1))}`}
//             alt={tour.name}
//             loading="lazy"
//           />
//           <div className={`type-badge`}>
//             {tour.type === "fit" ? "Private" : "Group"}
//           </div>
//         </div>

//         {/* Content Section - Compact Padding */}
//         <Card.Body className="rs-card-body-slim">
//           <div className="rs-main-content" onClick={handleCardClick}>
//             <h6 className="rs-tour-title-slim" title={tour.name}>
//               {tour.name}
//             </h6>
//           </div>
//           <div   className="rs-footer-slim">

//             Tour Includes:
//          <div 

//           style={{
//             gap: "10px",
//             // marginTop: "10px",
//             display: "flex",
//             justifyContent:"space-between"
//           }}>
//             {includesArray.map((item) => {
//               const option = includeOptions[item];
//               if (!option) return null; // skip unknown items
//               return (
//                 <div key={item}

//                 >
//                   <div className="icon-box-2">
//                     {option.icon}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           </div>

//         </Card.Body>
//           <div className="rs-footer-slim"
//           style={{
//             padding: "10px",
//             background:"#e4e8ec"
//           }}
//           >
//             {!showConnectForRateBtn ? (
//               <div className="rs-price-box"

//               >
//                 Starts at &nbsp;
//                 <span className="rs-price-amt" style={{
//                   fontSize: "20px"
//                 }}>
//                   ₹{tour.type === "fit" ? minFitPrice?.toLocaleString() : tour?.doubleOccupancy?.toLocaleString()}
//                 </span>
//                 <div className="rs-btn-group">
//                   {tour?.type == "fit" ? `${tour?.tour_itineraries?.length || 0} days ${tour?.tour_itineraries?.length - 1 || 0} nights` : `${tour?.duration || 0} days ${tour?.duration - 1} nights`}
//                 </div>
//               </div>
//             ) : (
//               <span className="rs-price-req">Price on Request</span>
//             )}


//           </div>
//            <div style={{
//             display: "flex",
//             justifyContent: "space-between",
//             fontSize: 13,
//             fontWeight: "600",
//             color: "#444",
//             padding: "10px",
//             borderTop: "1px solid #f1f1f1"
//           }}>
//             <Button
//               variant="link"
//               style={{ padding: 0, color: "#444", display: "flex", alignItems: "center", gap: 5 }}
//               onClick={() => setShowRateModal(true)}
//             >
//               <FaWhatsapp style={{ color: "#25D366" }} /> Request Callback
//             </Button>
//             <Button
//               variant="link"
//               style={{ padding: 0, color: "#444", display: "flex", alignItems: "center", gap: 5 }}
//               onClick={() => {/* handle get itinerary */ }}
//             >
//               <MdOutlineEmail /> Get Itinerary
//             </Button>
//           </div>
//       </Card>

//       {/* Booking/Inquiry Modal */}
//       <Modal show={showRateModal} onHide={() => setShowRateModal(false)} centered className="rs-modal">
//         <Modal.Header closeButton>
//           <Modal.Title className="fs-5 fw-bold">Connect for Rate</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={(e) => { e.preventDefault(); setShowRateModal(false); }}>
//             <Form.Group className="mb-2">
//               <Form.Label className="small fw-bold">NAME</Form.Label>
//               <InputGroup size="sm">
//                 <InputGroup.Text><IoPersonCircle /></InputGroup.Text>
//                 <Form.Control
//                   placeholder="Enter name"
//                   value={formData.name}
//                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                   required
//                 />
//               </InputGroup>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label className="small fw-bold">CONTACT</Form.Label>
//               <InputGroup size="sm">
//                 <InputGroup.Text><IoCallOutline /></InputGroup.Text>
//                 <Form.Control
//                   type="tel"
//                   maxLength={10}
//                   placeholder="10-digit number"
//                   value={formData.contactNumber}
//                   onChange={(e) => setFormData({ ...formData, contactNumber: e.target.value })}
//                   required
//                 />
//               </InputGroup>
//             </Form.Group>

//             <div className="d-flex gap-2 mb-3">
//               <div className="rs-counter flex-grow-1">
//                 <label className="d-block small text-center fw-bold mb-1">Adults</label>
//                 <div className="d-flex align-items-center justify-content-center gap-2">
//                   <Button variant="light" size="sm" onClick={() => setAdultCount(Math.max(1, adultCount - 1))}>-</Button>
//                   <span className="small fw-bold">{adultCount}</span>
//                   <Button variant="light" size="sm" onClick={() => setAdultCount(adultCount + 1)}>+</Button>
//                 </div>
//               </div>
//               <div className="rs-counter flex-grow-1">
//                 <label className="d-block small text-center fw-bold mb-1">Children</label>
//                 <div className="d-flex align-items-center justify-content-center gap-2">
//                   <Button variant="light" size="sm" onClick={() => setChildrenCount(Math.max(0, childrenCount - 1))}>-</Button>
//                   <span className="small fw-bold">{childrenCount}</span>
//                   <Button variant="light" size="sm" onClick={() => setChildrenCount(childrenCount + 1)}>+</Button>
//                 </div>
//               </div>
//             </div>

//             <Button type="submit" className="w-100 btn-primary-rs" disabled={!isFormValid}>
//               SEND ENQUIRY
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default TourCard;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Modal, Form} from "react-bootstrap";
import axios from "axios"; 
import BASE_URL from "../../component/commanfile";
import {
  BsPersonCheck,
  BsBuilding,
  BsBusFront,
  BsCamera,
  BsAirplane,
  BsSendPlusFill,
} from "react-icons/bs";


import {
  MdDinnerDining,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const TourCard = ({ tour, viewMode }) => {
  const navigate = useNavigate();
const today = new Date().toISOString().split("T")[0];
  // --- States ---
  const [showRateModal, setShowRateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Syncing with your requested data set
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    customerNotes: "",
    email: "",
    adults: "",         // New Field
    children: "",       // New Field
    tentativeDate: "",  // New Field
    type: "custom"
  });
  const [adultCount, setAdultCount] = useState(1);
  const [childrenCount, setChildrenCount] = useState(0);
  const [tourData, setTourData] = useState(null);
useEffect(() => {
  if (!showRateModal) {
    // When the modal closes, we wait a moment for the animation to finish, then reset
    const timer = setTimeout(() => {
      setFormData({
        name: "",
        mobile_number: "",
        customerNotes: "",
        email: "",
        adults: "1",
        children: "0",
        tentativeDate: "",
        type: "custom"
      });
      setSuccess("");
      setError("");
    }, 300); // 300ms matches standard modal fade-out time
    return () => clearTimeout(timer);
  }
}, [showRateModal]);
  // --- API Handler ---
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      // Constructing notes to include Pax details if needed
      const finalNotes = `${formData.customerNotes} (Adults: ${adultCount}, Children: ${childrenCount}, Tour: ${tour.name})`.trim();

      await axios.post(
        `${BASE_URL}api/tourinquery`,
        {
          name: formData.name,
          mobileNumber: formData.mobile_number, 
          customerNotes: finalNotes,
          email: formData.email,
          type: tourData?.type == "fit" ? "fit" : "package",
          selectedPackage:  tourData?.type == "fit" ? "" : tourData?.id,
          fitPackage: tourData?.type == "fit" ? tourData?.id : "",
          adults: formData.adults,
          children: formData.children,
          tentativeDate: formData.tentativeDate,
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      setSuccess("Inquiry sent successfully! Our team will contact you soon.");

      // Reset Form
 
      // Auto close modal
      // setTimeout(() => {
      //   setShowRateModal(false);
      //   setSuccess("");
      // }, 3000);

    } catch (err) {
      console.error("Tour inquiry error", err);
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleCardClick = () => {
    navigate(`/tour-details/${tour.type === "fit" ? `fit-${tour?.id}` : tour?.id}`, {
      state: { tourId: tour?.id }
    });
  };
  const theme = {
    primary: "#8f0909",
    dark: "#082e5e",
    light: "#f8f9fa"
  };
  const styles = {
    hero: {
      background: `linear-gradient(rgba(58, 57, 121, 0.8), rgba(10, 29, 55, 0.9)), 
                   url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1600&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: "100px 0 140px",
      textAlign: "center",
      position: "relative",
      width: "100%"
    },

    infoCard: {
      border: "none",
      borderRadius: "24px",
      padding: "30px",
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
      transition: "transform 0.3s ease",
      position: "relative",
      zIndex: 5
    },
    iconBox: {
      width: "55px",
      height: "55px",
      borderRadius: "15px",
      backgroundColor: "#fff1f1",
      color: theme.primary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.4rem",
      marginBottom: "20px"
    },
    input: {
      borderRadius: "12px",
      padding: "14px 20px",
      border: "1px solid #eee",
      backgroundColor: "#fcfcfc",
      fontSize: "0.95rem"
    }
  };
  // Price Calculation
  const forfitArray = Array.isArray(tour?.forfit) ? tour.forfit : tour?.forfit ? [tour.forfit] : [];
  let minFitPrice = null;
  if (tour.type === "fit") {
    forfitArray.forEach((item) => {
      item?.seatConfigurationRate?.forEach((rate) => {
        if (typeof rate?.price === "number") {
          if (minFitPrice === null || rate.price < minFitPrice) minFitPrice = rate.price;
        }
      });
    });
  }

  const showConnectForRateBtn = tour.type === "fit" && (minFitPrice === null || minFitPrice <= 0);

  // Inclusion Icons Logic
  let includesArray = [];
  try {
    includesArray = typeof tour?.includes === "string" ? JSON.parse(tour.includes) : (tour?.includes || []);
    if (!Array.isArray(includesArray)) includesArray = tour.includes.split(",").map(i => i.trim());
  } catch {
    includesArray = tour?.includes?.split(",").map(i => i.trim()) || [];
  }

  const includeOptions = {
    tour_manager: { icon: <BsPersonCheck />, label: "Tour Manager" },
    hotel: { icon: <BsBuilding />, label: "Hotel" },
    meals: { icon: <MdDinnerDining />, label: "Meals" },
    transport: { icon: <BsBusFront />, label: "Transport" },
    sightseeing: { icon: <BsCamera />, label: "Sightseeing" },
    flight: { icon: <BsAirplane />, label: "Flight*" },
  };
console.log("tour989898---", `${BASE_URL}${tour?.thumbnail?.substring(1)}` );
  return (
    <>
      <Card className={`rs-slim-card ${viewMode === "list" ? "rs-list-view" : ""}`}>
        <div className="rs-card-img-wrapper" onClick={handleCardClick}>
        <img
            src={`${BASE_URL}/api/image?file=${encodeURIComponent(tour?.thumbnail?.substring(1))}`}
            alt={tour.name}
  loading="lazy"
/>
          <div className="type-badge">{tour.type == "fit" ? "Private" : "Group"}</div>
        </div>

        <Card.Body className="rs-card-body-slim">
          <div className="rs-main-content" onClick={handleCardClick}>
            <h6 className="rs-tour-title-slim" title={tour.name}>{tour.name}</h6>
          </div>

          <div className="rs-footer-slim">
            <span className="small text-muted">Includes:</span>
            <div style={{ gap: "10px", display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
              {includesArray.map((item) => {
                const option = includeOptions[item];
                return option ? <div key={item} className="icon-box-2">{option.icon}</div> : null;
              })}
            </div>
          </div>
        </Card.Body>

        <div className="rs-footer-slim" style={{ padding: "10px", background: "#e4e8ec" }}>
          {!showConnectForRateBtn ? (
            <div className="rs-price-box">
              Starts at &nbsp;
              <span className="rs-price-amt" style={{ fontSize: "20px" }}>
                ₹{tour.type === "fit" ? minFitPrice?.toLocaleString() : tour?.doubleOccupancy?.toLocaleString()}
              </span>
              <div className="rs-btn-group">
                {tour?.type === "fit" ? `${tour?.tour_itineraries?.length || 0}D/${tour?.tour_itineraries?.length - 1 || 0}N` : `${tour?.duration || 0}D/${tour?.duration - 1}N`}
              </div>
            </div>
          ) : (
            <span className="rs-price-req">Price on Request</span>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: "600", color: "#444", padding: "10px", borderTop: "1px solid #f1f1f1" }}>
          <Button variant="link" className="p-0 text-decoration-none" style={{ color: "#444", display: "flex", alignItems: "center", gap: 5 }}
            onClick={() => {
              setShowRateModal(true)
              setTourData(tour)

            }}

          >
            <BsSendPlusFill style={{ color: "#0a3b78" }} /> Send Inquiry
          </Button>
          <Button variant="link" className="p-0 text-decoration-none" style={{ color: "#444", display: "flex", alignItems: "center", gap: 5 }}>
            <FaWhatsapp style={{ color: "#25D366" }} /> Get Itinerary
          </Button>
        </div>
      </Card>

      {/* --- Inquiry Modal --- */}
      <Modal show={showRateModal} onHide={() => !loading && setShowRateModal(false)} centered
        dialogClassName="custom-modal"
        size="lg" 
      >

   <div style={{ 
      ...styles.infoCard, 
      borderTop: `8px solid ${theme.primary}`, 
      padding: "40px",
      borderRadius: "20px" 
    }}>
      {/* Header Section */}
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <div>
          <h3 className="fw-bold mb-1" style={{ color: theme.dark, letterSpacing: "-0.5px" }}>
  Quick Inquiry
          </h3>
          <p className="text-muted mb-0">Fill in the details below and our travel experts will contact you.</p>
        </div>
        <button 
          onClick={() => setShowRateModal(false)} 
          style={{ border: 'none', background: '#f8f9fa', borderRadius: '50%', width: '35px', height: '35px', color: '#666' }}
        >
          ✕
        </button>
      </div>
  
      <Form onSubmit={handleSubmit}>
        {success ? (
        <div className="text-center py-5 animate__animated animate__fadeIn">
    {/* Animated Success Icon */}
    <div className="mb-4">
      <div style={{ 
        width: "100px", 
        height: "100px", 
        background: "#f0fff4", 
        color: "#28a745", 
        borderRadius: "50%", 
        display: "inline-flex", 
        alignItems: "center", 
        justifyContent: "center", 
        fontSize: "3rem",
        boxShadow: "0 10px 20px rgba(40, 167, 69, 0.1)"
      }}>
        ✓
      </div>
    </div>

    {/* The Professional Message */}
    <h3 className="fw-bold" style={{ color: theme.dark, marginBottom: "15px" }}>
      Inquiry Submitted Successfully!
    </h3>
    
    <div className="px-md-4">
      <p style={{ color: "#555", lineHeight: "1.6", fontSize: "1.05rem" }}>
        Dear <strong>{formData.name || "Traveler"}</strong>, thank you for choosing 
        Radheshyam Group. We have received your inquiry for the <strong>{tour?.name}</strong>.
      </p>
      
      <p className="text-muted small" style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "12px", borderLeft: `4px solid ${theme.primary}` }}>
        One of our senior destination experts will review your requirements. 
        You will receive a personalized itinerary and a best-price quote on your 
        provided mobile number/email within the next 24 hours.
      </p>
    </div>

    {/* Branded Footer */}
    <div className="mt-4 pt-3 border-top">
      <p className="mb-1 fw-bold" style={{ color: theme.primary }}>Radheshyam Group</p>
      <span className="text-muted small">Quality Tours • Trusted Service • Best Price</span>
    </div>

 
  </div>
        ) : (
          <>
            {/* Row 1: Name & Mobile */}
            <div className="row mt-2">
              <div className="col-md-6 mb-3">
                <Form.Label className="small fw-bold text-secondary text-uppercase">Full Name</Form.Label>
                <Form.Control
                  style={styles.input}
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="e.g. Rahul Sharma"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label className="small fw-bold text-secondary text-uppercase">Mobile Number</Form.Label>
                <Form.Control
                  style={styles.input}
                  type="tel"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  placeholder="+91 00000 00000"
                  required
                />
              </div>
            </div>
  
            {/* Row 2: Email */}
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-secondary text-uppercase">Email Address</Form.Label>
              <Form.Control
                style={styles.input}
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="name@example.com"
              />
            </Form.Group>
  
            {/* Row 3: Travel Details (The 3 New Fields) */}
            <div className="row p-3 mb-3" style={{ background: "#f8f9fa", borderRadius: "15px", border: "1px solid #eee" }}>
              <div className="col-md-4 mb-2">
                <Form.Label className="small fw-bold text-dark">Adults</Form.Label>
                <Form.Control
                  style={{...styles.input, border: "1px solid #ddd"}}
                  type="number"
                  min="1"
                  name="adults"
                  value={formData.adults}
                  onChange={handleChange}
                  placeholder="1"
                  required
                />
              </div>
              <div className="col-md-4 mb-2">
                <Form.Label className="small fw-bold text-dark">Children</Form.Label>
                <Form.Control
                  style={{...styles.input, border: "1px solid #ddd"}}
                  type="number"
                  min="0"
                  name="children"
                  value={formData.children}
                  onChange={handleChange}
                  placeholder="0"
                />
              </div>
              <div className="col-md-4 mb-2">
                <Form.Label className="small fw-bold text-dark">Travel Date</Form.Label>
                <Form.Control
                  style={{...styles.input, border: "1px solid #ddd"}}
                  type="date"
                  min={today}
                  name="tentativeDate"
                  value={formData.tentativeDate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
  
            {/* Row 4: Message */}
            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold text-secondary text-uppercase">Special Notes / Requirements</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                style={styles.input}
                name="customerNotes"
                value={formData.customerNotes}
                onChange={handleChange}
                placeholder="Tell us about the destinations you're interested in..."
                required
              />
            </Form.Group>
  
            {/* Submit Button */}
            <Button
              type="submit"
              className="w-100 py-3 border-0 shadow"
              style={{ 
                borderRadius: "12px", 
                fontWeight: "700", 
                backgroundColor: theme.dark,
                fontSize: "1.1rem",
                transition: "all 0.3s ease"
              }}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm me-2"></span>
              ) : null}
              {loading ? "PROCESSING..." : "SEND MESSAGE"}
            </Button>
          </>
        )}
        {error && <p className="text-danger small mt-3 text-center fw-bold">{error}</p>}
      </Form>
    </div>
      </Modal>
    </>
  );
};

export default TourCard;